import { AnalyticsActionName } from "@/models/analytics"
import { datadogRum } from "@datadog/browser-rum"

export type UploadStepType =
  | "additional usage"
  | "building data"
  | "interval usage data"
  | "meter data"
  | "usage data"
  | "user data"

type AnalyticsAction =
  (typeof AnalyticsActionName)[keyof typeof AnalyticsActionName]

const UPLOAD_ANALYTICS_ACTIONS: Partial<
  Record<UploadStepType, { error: AnalyticsAction; success: AnalyticsAction }>
> = {
  "building data": {
    error: AnalyticsActionName.DataUploadBuildingDataError,
    success: AnalyticsActionName.DataUploadBuildingDataSuccess,
  },
  "interval usage data": {
    error: AnalyticsActionName.DataUploadIntervalUsageDataError,
    success: AnalyticsActionName.DataUploadIntervalUsageDataSuccess,
  },
  "meter data": {
    error: AnalyticsActionName.DataUploadMeterDataError,
    success: AnalyticsActionName.DataUploadMeterDataSuccess,
  },
  "usage data": {
    error: AnalyticsActionName.DataUploadUsageDataError,
    success: AnalyticsActionName.DataUploadUsageDataSuccess,
  },
  "user data": {
    error: AnalyticsActionName.DataUploadUserDataError,
    success: AnalyticsActionName.DataUploadUserDataSuccess,
  },
}

export const trackUploadSuccess = (type: UploadStepType): void => {
  const action = UPLOAD_ANALYTICS_ACTIONS[type]?.success
  if (action) {
    datadogRum.addAction(action)
  }
}

export const trackUploadError = (type: UploadStepType): void => {
  const action = UPLOAD_ANALYTICS_ACTIONS[type]?.error
  if (action) {
    datadogRum.addAction(action)
  }
}
